import { render, staticRenderFns } from "./TheMenu.vue?vue&type=template&id=158e05ba&"
import script from "./TheMenu.vue?vue&type=script&lang=js&"
export * from "./TheMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../sfra-webpack-builder/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/lucia/proyectos/byl_salesforce/sfra-webpack-builder/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('158e05ba')) {
      api.createRecord('158e05ba', component.options)
    } else {
      api.reload('158e05ba', component.options)
    }
    module.hot.accept("./TheMenu.vue?vue&type=template&id=158e05ba&", function () {
      api.rerender('158e05ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app_byl_core/cartridges/app_byl_core/cartridge/client/default/js/vue/components/TheMenu.vue"
export default component.exports